<template>
  <div class="pt pb">
    <div v-for="(item,index) in flowList" :key="index">
      <div class style="padding: 15px;">
        <div class="package-title mb">{{ item.title }}</div>
        <div class="flex justify-content-space-between text-muted mb-xs">
          <div>
            已用
            <span :class="item.used_flow < item.total_flow ? 'text-warning' : 'text-danger'">{{ Number.isInteger(item.used_flow) ? item.used_flow + 'M' : item.used_flow.toFixed(2) + 'M' }}</span>
          </div>
          <div>{{ '剩余' + (Number.isInteger(item.total_flow - item.used_flow) ? (item.total_flow - item.used_flow) : (item.total_flow - item.used_flow).toFixed(2)) + 'M/共' + item.total_flow + 'M' }}</div>
        </div>
        <el-progress
          :show-text="false"
          :percentage="item.used_flow / item.total_flow * 100 > 100 ? 100 : item.used_flow / item.total_flow * 100"
          :stroke-width="10"
          :status="item.used_flow >= item.total_flow ? 'exception' : 'success'"
          class="data-progress"
        ></el-progress>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    flowList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
    };
  },
  created() {},

  mounted() {
    
  },
  methods: {

  }
};
</script>
